import { RcFile } from 'antd/es/upload';

class Base64 {
  static encode = (input: string): string => Buffer.from(input, 'utf8').toString('base64');
  static decode = (input: string) => {
    let output = '';
    try {
      output = Buffer.from(input, 'base64').toString('utf8');
    } catch (error) {
      console.error(error);
    }
    return output;
  };

  static getBase64FromRcFile = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
}

export default Base64;
